import { inject, Injectable } from '@angular/core';
import { SocketService } from '../socket.service';
import { Api } from '../api';

@Injectable({
  providedIn: 'root'
})
export class DisconnectionService {
  public socketService = inject(SocketService);
  public api = inject(Api);

  public msg: string = "Die Verbindung zum Server wurde unterbrochen.";

  public disconnectionDetected: boolean = false
  protected reloadFn: () => void = () => window.location.reload();

  constructor(
  ) {
    this.socketService.disconnectionSubject.subscribe(msg => {
      this.msg = msg;
      this.disconnectionDetected = true;
    })
  }

  public async retryConnection() {
    this.msg = "Starte Verbindungsaufbau."
    const connectionPossible = await this.api.checkConnection();
    if (connectionPossible) {
      this.reloadPage();
    } else {
      this.msg = "Die Verbindung zum Server konnte nicht wieder hergestellt werden.";
    }

  }

  protected reloadPage() {
    this.reloadFn();
  }
}
